import React, { useContext, useRef, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { UserContext } from "shared/context/UserContext";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import { GridColumn } from "@progress/kendo-react-grid";
import {
    DefaultColumnWidth,
    DefaultWideColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";
import axios from "axios";

import {
    Base64ToArrayBuffer,
    SaveByteArray,
} from "shared/helpers/Base64ArrayTranslator";
import { OrganizationTypes } from "shared/constants/OrganizationTypes";

export function TparHistory(props) {
    const { passedProps } = props;
    const gridRef = useRef(null);
    const userConfig = useContext(UserContext);
    let user = userConfig.email || "";

    // State for grid API parameters
    const tparGridApiParams = useMemo(() => {
        if (userConfig.currentOrganization.value) {
            // NOTE (NETX-5821): only a ParentCompany org yields a valid RPID; a Group user's
            // currentOrganization.value is the GROUP id and is rejected (403) by GetTPARHistoryData.
            let selectedParentCompanyId =
                passedProps.parentCompanySetByGroupUser &&
                    passedProps.parentCompanySetByGroupUser.rpid
                    ? passedProps.parentCompanySetByGroupUser.rpid
                    : userConfig.currentOrganization.type === OrganizationTypes.ParentCompany
                    ? userConfig.currentOrganization.value
                    : null;

            if (selectedParentCompanyId) {
                return {
                    rpid: selectedParentCompanyId
                }
            }
        }
    }, [userConfig.currentOrganization.value, userConfig.currentOrganization.type, passedProps.parentCompanySetByGroupUser]);

    const CustomActionCell = (props) => (
        <CustomCell {...props} color={"#015CAB"} />
    );

    const CustomCell = (props) => {
        async function downloadClick(event) {
            const accessToken = await passedProps.auth.getAccessToken();
            var fileName = props.dataItem.reportName + "-en-" + props.dataItem.rpid + "_" + props.dataItem.id + ".xlsx";

            const response = await axios.get(`api/ThirdPartyReceivable/DownloadFromFileShare`, {
                params: {
                    fileNameInput: fileName,
                    rpidInput: props.dataItem.rpid
                },
                headers: { Authorization: `Bearer ${accessToken}` },
            }).then((response) => {
                if (response.data) {
                    var dataAsArray = Base64ToArrayBuffer(response.data);
                    SaveByteArray(fileName, dataAsArray);
                } else {
                    alert("Unable to download the report, please contact Net-Rx support.");
                }
            })
                .catch((error) => {
                    alert("Unable to download the report, please contact Net-Rx support.");
                });
        }

        return (
            <td
                {...props.tdProps}
                colSpan={1}
                style={{
                    color: "#015CAB",
                }}
            >
                <a
                    style={{
                        cursor: "pointer",
                    }}
                    onClick={downloadClick}
                >
                    Download
                </a>
            </td>
        );
    };

    return (
        <div className="feature">
            <h6>For your convenience, historical reports will be available for six months.</h6>
            <Row>
                <Col className="tight-grid multi-line-filter">
                    <SharedMainSelectableClientGrid
                        ref={gridRef}
                        apiGetEndpoint={"api/ThirdPartyReceivable/GetTPARHistoryData"}
                        disableCache={true}
                        apiParameters={tparGridApiParams}
                        dataItemKey={"kendoGridId"}
                        exportFileNamePrefix={"ThirdPartyReceivableHistory"}
                        selectionColumntitle={"Select"}
                        isSelectable={false}
                        pageSize={100}
                    >
                        <GridColumn
                            key={"id"}
                            field={"id"}
                            title={"Action"}
                            filterable={false}
                            sortable={false}
                            cells={{
                                data: CustomActionCell,
                            }}
                            width={DefaultColumnWidth()}
                        />
                        <GridColumn
                            field="reportStatus"
                            title="Status"
                            width={DefaultColumnWidth()}

                        />
                        <GridColumn
                            field="createdDateTime"
                            title="Creation Time"
                            filter="date"
                            format="{0:d}"
                            width={DefaultColumnWidth()}

                        />
                        <GridColumn
                            field="startDate"
                            title="Report Start Date"
                            filter="date"
                            format="{0:d}"
                            width={DefaultColumnWidth()}

                        />
                        <GridColumn
                            field="endDate"
                            title="Report End Date"
                            filter="date"
                            format="{0:d}"
                            width={DefaultColumnWidth()}

                        />
                        <GridColumn
                            field="reportName"
                            title="Report Name"
                            width={DefaultWideColumnWidth()}
                        />
                        <GridColumn
                            field="submittedBy"
                            title="Submitted By"
                            width={DefaultColumnWidth()}

                        />
                    </SharedMainSelectableClientGrid>
                </Col>
            </Row>
        </div>
    );
}